// extracted by mini-css-extract-plugin
export default {"btnPos":"StripeS7Modules_btnPos__IWWcV","scrollFor":"StripeS7Modules_scrollFor__uoob3","ant-card-actions":"StripeS7Modules_ant-card-actions__yI8PI"};